import { render, staticRenderFns } from "./HeaderGroupDropdown.vue?vue&type=template&id=84222e62&scoped=true"
import script from "./HeaderGroupDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderGroupDropdown.vue?vue&type=script&lang=js"
import style0 from "./HeaderGroupDropdown.vue?vue&type=style&index=0&id=84222e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84222e62",
  null
  
)

export default component.exports